import { render, staticRenderFns } from "./PriceWithDetails.vue?vue&type=template&id=1a53aab9"
import script from "./PriceWithDetails.vue?vue&type=script&lang=ts"
export * from "./PriceWithDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports